export const borderRadius = {
  small: '3px',
  base: '4px',
  large: '5px',
};
